import React, { useState, useEffect } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import sad from "../Assests/Images/AssessmentFeedback/Sad.svg";
import Neutral from "../Assests/Images/AssessmentFeedback/Netural.svg";
import happy from "../Assests/Images/AssessmentFeedback/Happy.svg";
import Dhappy from "../Assests/Images/AssessmentFeedback/DisableHappy.svg";
import Dnetural from "../Assests/Images/AssessmentFeedback/DisableNetural.svg";
import Dsad from "../Assests/Images/AssessmentFeedback/DisableSad.svg";
import CopyRight from "../Reusablecomponents/Copyright";
import InternetChecking from "../Reusablecomponents/Network";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const AssFeedBack = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));

  const [FBQuestions, SetFBQuestions] = useState();
  const [StudentFB, SetStudentFB] = useState([]);
  const GetFeedBackQuestions = async () => {
    try {
      const res = await axiosInstance.get(
        "/Assessment/GetStudentAssessmentFeedbackQuestions"
      );
      console.log("res", res.data);
      SetFBQuestions(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    document.exitFullscreen();
    GetFeedBackQuestions();
  }, []);
  const StoreRating = (QId, FB) => {
    SetStudentFB({ ...StudentFB, [QId]: FB });
  };
  const Images = [
    { Img: happy, Alt: "happy", DImg: Dhappy },
    { Img: Neutral, Alt: "Neutral", DImg: Dnetural },
    { Img: sad, Alt: "sad", DImg: Dsad },
  ];
  const SubmitFeedback = async () => {
    try {
      const res = await axiosInstance.get(
        `/Assessment/UpdateStudentAssessmentFeedback?UserId=${
          items?.userId
        }&ContestCreationId=${
          AssessmentData?.contestCreationID
        }&Rating=${Object.values(StudentFB).join(",")}`
      );
      navigate("/Student/Results", { replace: true });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className="Instructions-pages VASheet dflex flexd-column JCCenter">
      <InternetChecking />
      <div className="MainHeading mb-3">
        Please provide your feedback for the assessment
      </div>
      <div
        className="dflex gap-2 flexd-column Card "
        style={{ backgroundColor: "#DCF7EF" }}
      >
        {FBQuestions?.filter((item) => item.sets === "Set1").map(
          (question, index) => (
            <div className="dflex alignitems JSBetween">
              {index + 1}) {question?.question}
              <div className="ASSFeedback-emojis">
                {Images.map((SIMG, IMGindex) => (
                  <img
                    src={
                      StudentFB[question?.questionId] === IMGindex + 1
                        ? SIMG?.Img
                        : SIMG?.DImg
                    }
                    alt={SIMG?.Alt}
                    onClick={() =>
                      StoreRating(question?.questionId, IMGindex + 1)
                    }
                  />
                ))}
              </div>
            </div>
          )
        )}
        <div className="dflex JSBetween mt-3">
          <div></div>
          <button
            className="Buttons "
            style={{ width: "15%" }}
            onClick={() => {
              SubmitFeedback();
            }}
          >
            Submit
          </button>
        </div>
      </div>
      <CopyRight />
    </div>
  );
};
export default AssFeedBack;
